import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { unFormatCurrency, unFormatUnknownUnit } from '@/common/utils/unFormatters'
import {
  PublicCompanyLeadsFunnelContractProductCategoryValidationSchema,
  PublicCompanyLeadsFunnelUpdateContractProductPriceValidationSchema,
  PublicCompanyLeadsFunnelUpdateContractProductValidationSchema,
} from '../schemas/update.schema'
import { ContractProductCategoryData, ContractProductCategoryProductData } from '../types/publicCompanyLead'

export const transformNewContractProductCategory = (
  formContractProductCategory: PublicCompanyLeadsFunnelContractProductCategoryValidationSchema,
  contractProductCategories: ContractProductCategoryData[],
  isConsumptionControlledByQuantity?: boolean,
) => {
  const contractProductCategory = contractProductCategories.find(
    ({ product_category }) => product_category.id === formContractProductCategory.product_category.id,
  )

  return {
    product_category_id: formContractProductCategory.product_category?.id,
    global_value_in_currency:
      !!formContractProductCategory?.require_product_credit_quota &&
        !!formContractProductCategory.global_value_in_currency &&
        !isConsumptionControlledByQuantity
        ? unFormatCurrency(formContractProductCategory.global_value_in_currency)
        : null,
    global_value_in_unit_for_consumption:
      !!formContractProductCategory?.require_product_credit_quota &&
        formContractProductCategory.global_value_in_unit_for_consumption
        ? unFormatUnknownUnit(formContractProductCategory.global_value_in_unit_for_consumption)
        : null,
    contract_product_category_products_attributes: [
      ...getRailsUpdate(
        contractProductCategory?.contract_product_category_products || [],
        formContractProductCategory.contract_product_category_products || [],
        (x) => x.product.id,
        (y) => y.product.id,
        mapToDeletion,
        (newFormContractProductCategoryProduct) =>
          transformNewContractProductCategoryProduct(
            newFormContractProductCategoryProduct,
            contractProductCategory?.contract_product_category_products || [],
            formContractProductCategory.require_product_credit_quota,
            isConsumptionControlledByQuantity,
          ),
      ),
      ...(formContractProductCategory.contract_product_category_products
        ?.filter((contractProductCategoryProduct) => !!contractProductCategoryProduct.id)
        ?.map((formContractProductCategoryProduct) => ({
          ...transformNewContractProductCategoryProduct(
            formContractProductCategoryProduct,
            contractProductCategory?.contract_product_category_products || [],
            formContractProductCategory.require_product_credit_quota,
            isConsumptionControlledByQuantity,
          ),
          id: formContractProductCategoryProduct.id,
          product_id: undefined,
        })) || []),
    ],
  }
}

export const transformNewContractProductCategoryProduct = (
  formContractProductCategoryProduct: PublicCompanyLeadsFunnelUpdateContractProductValidationSchema,
  contractProductCategoryProducts: ContractProductCategoryProductData[],
  require_product_credit_quota: boolean,
  isConsumptionControlledByQuantity?: boolean,
) => {
  const contractProductCategoryProduct = contractProductCategoryProducts.find(
    ({ product }) => product.id === formContractProductCategoryProduct.product.id,
  )

  return {
    product_id: formContractProductCategoryProduct.product?.id,
    global_value_in_currency:
      !!require_product_credit_quota &&
        !!formContractProductCategoryProduct.global_value_in_currency &&
        !isConsumptionControlledByQuantity
        ? unFormatCurrency(formContractProductCategoryProduct.global_value_in_currency)
        : null,
    global_value_in_unit_for_consumption:
      !!require_product_credit_quota && !!formContractProductCategoryProduct.global_value_in_unit_for_consumption
        ? unFormatUnknownUnit(formContractProductCategoryProduct.global_value_in_unit_for_consumption)
        : null,
    price_rule: formContractProductCategoryProduct.price_rule?.value,
    contract_product_category_product_prices_attributes:
      formContractProductCategoryProduct.price_rule?.value === 'fixed'
        ? formContractProductCategoryProduct.filterByRegion
          ? [
            ...getRailsUpdate(
              contractProductCategoryProduct?.contract_product_category_product_prices || [],
              formContractProductCategoryProduct.contract_product_category_product_prices || [],
              (x) => x.id,
              (y) => y.id || '',
              mapToDeletion,
              (newFormProductPrice) => transformNewContractProductCategoryProductPrice(newFormProductPrice),
            ),
            ...(formContractProductCategoryProduct.contract_product_category_product_prices
              ?.filter((contractProductCategoryProductPrice) => !!contractProductCategoryProductPrice.id)
              .map((formContractProductCategoryProductPrice) => ({
                ...transformNewContractProductCategoryProductPrice(formContractProductCategoryProductPrice),
              })) || []),
          ]
          : [
            {
              id: formContractProductCategoryProduct.contract_product_category_product_prices?.[0].id,
              geo_id: null,
              geo_type: null,
              value: formContractProductCategoryProduct.contract_product_category_product_prices?.[0].value
                ? unFormatCurrency(
                  formContractProductCategoryProduct.contract_product_category_product_prices?.[0].value,
                )
                : undefined,
            },
          ]
        : null,
  }
}

export const transformNewContractProductCategoryProductPrice = (
  formContractProductCategoryProductPrice: PublicCompanyLeadsFunnelUpdateContractProductPriceValidationSchema,
) => {
  return {
    id: formContractProductCategoryProductPrice.id,
    geo_id: formContractProductCategoryProductPrice?.geo?.value,
    geo_type: formContractProductCategoryProductPrice?.geo?.type,
    value: formContractProductCategoryProductPrice.value
      ? unFormatCurrency(formContractProductCategoryProductPrice.value)
      : undefined,
  }
}
